import Vue from "vue";
import VueRouter from "vue-router";

import App from "./App.vue";
import VueMeta from "vue-meta";
import Posts from "./components/Posts.vue";
import Post from "./components/Post.vue";
import Page from "./components/Page.vue";
import Landing from "./components/Landing.vue";
import EquipesMobiles from "./components/EquipesMobiles.vue";
import ProtectedPage from "./components/ProtectedPage.vue";

import Jobs from "./components/Jobs.vue";
import SubmitJob from "./components/SubmitJob.vue";
import NotFound from "./components/NotFound.vue";
import "./../node_modules/bulma/css/bulma.css";

import Buefy from "buefy";
import "buefy/dist/buefy.css";
Vue.use(Buefy);

Vue.config.productionTip = false;

import VueSanitize from "vue-sanitize";
Vue.use(VueSanitize, {
  allowedTags: [
    "a",
    "b",
    "i",
    "em",
    "strong",
    "p",
    "br",
    "ul",
    "ol",
    "li",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "pre",
    "code",
    "img",
  ],
  allowedAttributes: {
    a: ["href", "name", "target"],
    img: ["src", "alt", "title", "width", "height"],
  },
  allowedSchemes: ["http", "https", "ftp", "mailto"],
  stripIgnoreAttributes: true,
});
Vue.use(VueRouter);
Vue.use(VueMeta);

function dynamicPropsFn(route) {
  //const tab_pres = ['missions', 'equipe', 'contact']
  const tab_ensei = ["enseignement", "option-ppa"];
  const tab_recherche = ["recherche", "publications"];
  var res = null;
  if (tab_ensei.includes(route.params.id)) {
    res = "enseignement";
  } else if (tab_recherche.includes(route.params.id)) {
    res = "recherche";
  }
  return {
    pagetab: res,
  };
}

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: Landing, name: "home" },
    //{ path: '/presentation/:id', component: Page, props: { presentationTabs: true } },
    { path: "/espace_professionnel", component: ProtectedPage },
    { path: "/equipesmobiles/:tab?/:equipe?", component: EquipesMobiles },
    { path: "/page/emploi", component: Jobs },
    { path: "/page/emploi/soumettre", component: SubmitJob },
    { path: "/page/:id", component: Page, props: dynamicPropsFn },
    { path: "/post/:id", component: Post },
    //{ path: '/test', component: EquipesMobilesAlt },
    { path: "/actualites", component: Posts },
    { path: "/404", alias: "*", component: NotFound, name: "404" },
  ],
  scrollBehavior: function(to) {
    if (to.hash) {
      if (to.hash === "#top") {
        return { x: 0, y: 0, behavior: "smooth" };
      } else {
        return { selector: to.hash, behavior: "smooth" };
      }
    } else {
      //return { x: 0, y: 0, behavior: 'smooth' }
    }
  },
});

var moment = require("moment");
moment.locale("fr");
// filters
Vue.filter("formatTimestamp", function(value) {
  if (value) {
    return moment.unix(value).format("DD/MM/YYYY");
  }
});
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
  }
});
Vue.filter("formatDate2", function(value) {
  if (value) {
    return moment(value, "YYYY-MM-DD").format("MMMM YYYY");
  }
});
Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("truncate", function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});

Vue.prototype.$api_url_base = process.env.VUE_APP_APIPURI;
Vue.prototype.$api_key = process.env.VUE_APP_APIKEY;
Vue.prototype.$api_url_posts =
  Vue.prototype.$api_url_base +
  "/api/collections/get/post?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_pages =
  Vue.prototype.$api_url_base +
  "/api/collections/get/page?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_contact =
  Vue.prototype.$api_url_base +
  "/api/forms/submit/contact?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_menu =
  Vue.prototype.$api_url_base +
  "/api/collections/get/Menu?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_emobiles =
  Vue.prototype.$api_url_base +
  "/api/collections/get/equipesmobiles?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_jobs =
  Vue.prototype.$api_url_base +
  "/api/collections/get/jobs?token=" +
  Vue.prototype.$api_key;
Vue.prototype.$api_url_postjob =
  Vue.prototype.$api_url_base +
  "/api/collections/save/jobs?token=" +
  Vue.prototype.$api_key;

Vue.prototype.$share_hashtag = "CRRPSA";

// si code google analytics renseigner env var "VUE_APP_GTAG"
import VueGtag from "vue-gtag";
if (process.env.VUE_APP_GTAG && process.env.VUE_APP_GTAG.length > 10) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG },
  });
}

// global mixin
Vue.mixin({
  // update paths from API
  updated: function() {
    var curloc = window.location.origin;

    if (this.$el instanceof Element || this.$el instanceof HTMLDocument) {
      // liens vers pages
      const links = this.$el.querySelectorAll("a[href^='collection://']");
      links.forEach((link) => {
        link.href = link.href.replace("collection://", "#/");
      });
      // liens fichiers
      const links2 = this.$el.querySelectorAll("a[href^='/storage']");
      links2.forEach((link) => {
        var newhref = link.href.replace(curloc, "");
        newhref = this.$api_url_base + newhref;
        link.href = newhref;
        link.target = "_blank";
      });
      // liens images
      const imgs = this.$el.querySelectorAll("img[src^='/storage']");
      imgs.forEach((img) => {
        var newsrc = img.src.replace(curloc, "");
        newsrc = this.$api_url_base + newsrc;
        img.src = newsrc;
      });
    }
  },
  metaInfo() {
    return {
      title: this.maintitle,
      meta: [{ vmid: "title", name: "title", content: this.title }],
    };
  },
});

new Vue({
  render: (h) => h(App),
  router: router,
  data: function() {
    return {};
  },
}).$mount("#app");

//listeners
document.addEventListener("DOMContentLoaded", () => {
  // close notifications
  (document.querySelectorAll(".notification .delete") || []).forEach(
    ($delete) => {
      var $notification = $delete.parentNode;
      $delete.addEventListener("click", () => {
        $notification.parentNode.removeChild($notification);
      });
    }
  );
});
